import { HOTEL_PAGE_SEARCH_REQUEST_TIMEOUT } from '@/js/common/Constants/hotelPageSearchConstants';
import setAdditionalMetaOptions from '@/js/common/Service/setAdditionalMetaOptions';
import getABTestValue from '@/js/common/Domain/Service/getABTestValue';
import requestService from './request';

export default (tourCriteriaForTourRequest, callback) => requestService({
    cache: false,
    timeout: HOTEL_PAGE_SEARCH_REQUEST_TIMEOUT,
    url: `${window.appConfig.apiGatewayUrl}/frontend/${tourCriteriaForTourRequest.rooms?.length ? 'groupedTours' : 'tours'}`,
    data: {
        ...tourCriteriaForTourRequest,
        ...setAdditionalMetaOptions(),
        allToursPerHotel: 1,
        sections: ['countries', 'rooms', 'operators', 'routes', 'legs', 'firstPaymentDefinitions', 'airlines'],
        abTests: getABTestValue(),
    },
}, callback);